var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lineitem"},[_c('h2',{staticClass:"item-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"item-row",class:_vm.rowClass},[_c('p',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(item.description))])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac1a39c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LineItemCard.vue
// module id = null
// module chunks = 